<template>
  <div>
    <v-app-bar
      app
      height="96"
      absolute
      hide-on-scroll
    >
    <div class="btn-group d-flex align-items-center justify-content-between">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up azul"></v-app-bar-nav-icon>
        <v-img
          alt="Editora do Brasil"
          class="shrink ml-4"
          contain
          src="@/assets/logo-ebsa-fonte-azul.svg"
          transition="scale-transition"
          width="142"
        />       
      </div>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
          <v-btn class="primary--text bot-1" @click="abrirModalLogin" text>Acessar</v-btn>
          <v-btn class="primary--text bot-2" @click="dialog = true" text>Cadastre-se</v-btn>
      </v-toolbar-items> 
    </v-app-bar>

    <!-- modal login -->
 <v-dialog v-model="dialoglogin" persistent max-width="930px">
      <v-btn color="blue darken-1" class="bot-exit" text @click="dialoglogin = false">
          <v-img src="@/assets/iconexit.png" title="Sair" />
      </v-btn>
      <v-card>
            
            <div class="form login-box">
              <v-card class="login">
                <keep-alive><!-- keep-alive mantém os dados quando troca de componente-->
                  <component v-bind:is="component" />
                </keep-alive>
                <div class="box-botoes-login2">
                  <v-col cols="6" class="p-0 box-entrar">
                    <v-btn rounded v-on:click="toggle" v-show="!btnEsqueciSenhaVoltar" class="primary--text bot-1" block text dark>Esqueci a Senha</v-btn>
                  </v-col>  
                                   
                </div>
                <v-btn rounded v-on:click="toggle" v-show="btnLoginVoltar" class="primary--text bot-voltar oiu hidden" text dark>Voltar</v-btn>
                    
              </v-card>
            </div>
      </v-card>

    </v-dialog>

    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="930px">
          <v-btn color="blue darken-1" class="bot-exit" text @click="dialog = false">
            <v-img src="@/assets/iconexit.png" title="Sair" />
          </v-btn>
          <v-card>
            <div class="titulo-cadastro">
              <h1>Faça seu cadastro e aproveite!</h1>
              <h5>Exclusivo para professores e gestores</h5>
              <hr>
            </div>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <h5>Dados pessoais</h5>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-select 
                        v-model="perfil" 
                        :items="listaPerfil" 
                        :item-text="'text'" 
                        :item-value="'value'" 
                        :rules="perfilRules" 
                        label="Perfil*" 
                        required>
                      </v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="nome"
                        :rules="nomeRules"
                        label="Nome Completo*"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        type="number"
                        v-model="telefone"
                        label="Telefone fixo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        type="number"
                        v-model="celular"
                        :rules="celularRules"
                        label="Celular*"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail*"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        type="password"
                        v-model="senha"
                        :rules="senhaRules"
                        label="Senha*"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        type="password"
                        v-model="confirmarSenha"
                        :rules="confirmarSenhaRules"
                        label="Confirme sua senha*"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <h5>Dados da escola</h5>
                      <p>Indique a localidade e a rede de ensino de sua escola.</p>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                      <v-select 
                        v-model="uf" 
                        :items="listaUf" 
                        :rules="ufRules"
                        label="UF*" 
                        @change="getCidades()" 
                        required>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="9" md="9">
                      <v-select 
                        v-model="cidades" 
                        :items="listaCidades" 
                        :rules="cidadesRules"
                        label="Cidade*"  
                        @change="getEscolas()" 
                        required>
                      </v-select>
                    </v-col>
                    <!-- <v-col cols="12" sm="3" md="3">
                      <v-select :items="['0-17', '18-29', '30-54', '54+']" label="Rede de ensino*" required></v-select>
                    </v-col> -->
                    <v-col cols="12">
                      <v-select 
                        return-object 
                        v-model="escolas" 
                        :items="listaEscolas" 
                        :item-text="'text'" 
                        :item-value="'id'" 
                        :rules="escolasRules"
                        label="Nome da escola*" 
                        required>
                      </v-select>
                    </v-col>
                    <v-col cols="12">
                      <small>*Campos obrigatórios</small>
                    </v-col>
                    <v-col cols="12">
                      <h5>Termo de consentimento</h5>
                      <p class="texto-termo">Ao preencher este formulário, dou o meu consentimento (que poderá ser revogado a qualquer tempo) para que os meus dados pessoais sejam coletados e tratados exclusivamente pela Editora do Brasil com a finalidade de receber notícias, publicidade personalizada sobre seus produtos, serviços ou outras informações; melhoria de seus produtos e serviços através da análise dos dados fornecidos; em conformidade com os termos do Aviso de Privacidade da empresa ( <a href="https://conteudos.editoradobrasil.com.br/politicas/politicas-de-cookies-e-privacidade.pdf" target="_blank" rel="noopener noreferrer">clique aqui para acessar</a> ).</p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>              
              <v-btn color="blue darken-1" class="bot-3" text @click="validar()" :disabled="!valid">
                Cadastrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>


      <v-navigation-drawer class="menu-header-mobile" v-model="drawer" absolute temporary>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          active-class="primary--text text--accent-4"
        >
          <v-list-item class="mt-4 mb-4">
            <v-list-item-icon>
              <v-icon color="primary">assignment</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <a class="primary--text" @click="dialog = true">Cadastre-se</a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-4 mb-4"></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">mail</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <a class="primary--text" href="//editoradobrasil.com.br/fale-conosco" target="_blank">Contato</a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>         
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-snackbar rounded="pill" :color="snackbarColor" v-model="snackbar" :timeout="timeout">
          {{ snackbarText }}             
    </v-snackbar>
  </div>
</template>

<script>

import { http } from "../services/APIservice";
import '../plugins/modal-cadastro/css/style.scss';
import Login from './Login.vue';
//import EsqueciSenha from './EsqueciSenha.vue';
import $ from 'jquery';

$('button.bot-exit').fadeIn();

export default {
  name: 'HeaderHome',
  props: {
    dialoglogin: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Login,
    //EsqueciSenha
  },
  data: () => ({
    component:"Login",
    valid: false,
    drawer: false,
    dialog: false,
    dialoglogin: false,
    btnEsqueciSenhaVoltar: false,
    perfil: null,
    listaPerfil: [],
    nome: "",
    nomeRules: [
      v => !!v || 'Preencha o campo corretamente, por favor!',
      v => v.length >= 10 || 'O nome deve conter no mínimo 10 caracteres.',
    ],
    email: "",
    emailRules: [
      v => !!v || 'Preencha o campo corretamente, por favor!',
      v => /.+@.+/.test(v) || 'E-mail inválido',
    ],
    telefone: "",
    // telefoneRules: [
    //   v => v.length >= 10 || 'Telefone deve conter no mínimo 10 caracteres',
    //   v => v.length <= 11 || 'Telefone deve conter no máximo 11 caracteres',
    // ],
    celular: "",
    celularRules: [
      v => !!v || 'Preencha o campo corretamente, por favor!',
      v => v.length >= 10 || 'Celular deve conter no mínimo 10 caracteres',
      v => v.length <= 11 || 'Celular deve conter no máximo 11 caracteres',
    ],
    senha: "",
    confirmarSenha: "",
    uf: null,
    listaUf: [],
    cidades: null,
    listaCidades: [],
    escolas: null,
    listaEscolas: [],
    timeout: 15000,
    snackbar: '',
    snackbarColor: '',
    snackbarText: ''
  }),
  methods: {
    abrirModalLogin() {
      this.$emit('update:dialoglogin', true);
    },
    getPerfil() {
      return http.get("cadastrar/ListarTipoPerfil")
      .then(res => {       
        this.listaPerfil = res.data;
      })
      .catch(error => {
          console.log(error.res.status);
      });
    },
    getUf() {
      return http.get("cadastrar/ListarUf")
      .then(res => {       
        this.listaUf = res.data;
      })
      .catch(error => {
          console.log(error.res.status);
      });
    },
    getCidades() {
      let data = {
        "uf": this.uf
      }
      
      return http.post("cadastrar/ListarCidades", data)
      .then(res => {       
        this.listaCidades = res.data;
      })
      .catch(error => {
          console.log(error.res.status);
      });
    },
    getEscolas() {
      let data = {
        "uf": this.uf,
        "cidade": this.cidades,
      }
      
      return http.post("cadastrar/ListarEscolas", data)
      .then(res => {       
        this.listaEscolas = res.data;
        console.log(this.listaEscolas);
      })
      .catch(error => {
          console.log(error.res.status);
      });
    },
    validar() {
      if(this.$refs.form.validate()) {
        this.cadastrar();
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    cadastrar() {
      let data = {
        "Email": this.email,
        "codEscola": this.escolas.id,
        "Nome": this.nome,
        "Senha": this.confirmarSenha,
        "DDDCelular": "",
        "Celular": this.celular,
        "DDDTelefone": "",
        "Telefone": this.telefone,
        "Tipo": this.perfil,
        "TermoUso": true
      }
      console.log(data);
      
      return http.post("Cadastrar/CadastrarDegustacao", data)
  .then(res => {       
    if (res.status == 200) {
      this.setSnackbar("Cadastro Realizado com Sucesso!", "primary");
      this.dialog = false;
    } else if (res.status == 210) {          
      this.setSnackbar("Seu acesso não possui um convite para fazer degustação, favor entrar em contato com o seu consultor!", "error");
      this.dialog = false;
      this.reset();
    } else if (res.status == 203 || res.status == 204) {          
      this.setSnackbar("Você não possui o convite para degustação do Portal. Favor verificar com o seu Consultor de Vendas!", "error");
      this.dialog = false;
      this.reset();
    }
  })
  .catch(error => {
    console.log(error.response); // Corrigido para 'error.response', caso o erro venha de uma resposta do servidor.
  });      
    },
    setSnackbar(texto, cor) {
      this.snackbarText = texto;
      this.snackbarColor = cor;
      this.snackbar = true;
    },
  },
  mounted() {
    this.getPerfil();
    this.getUf();
  },
  computed: {
    perfilRules() {
      const rules = [
        v => !!v || 'Selecione o perfil, por favor!',
      ]
      return rules
    },
    senhaRules() {
      const rules = [
        v => !!v || 'Preencha o campo corretamente, por favor!',
        v => v.length >= 4 || 'Senha deve conter no mínimo 4 caracteres.',
      ]
      return rules
    },
    confirmarSenhaRules() {
      const rules = []

      if (this.senha) {
        const rule =
          v => (!!v && v) === this.senha ||
            'As senhas não conferem.'

        rules.push(rule)
      }

      return rules
    },
    ufRules() {
      const rules = [
        v => !!v || 'Selecione o UF, por favor!',
      ]
      return rules
    },
    cidadesRules() {
      const rules = [
        v => !!v || 'Selecione a cidade, por favor!',
      ]
      return rules
    },
    escolasRules() {
      const rules = [
        v => !!v || 'Selecione a escola, por favor!',
      ]
      return rules
    },
  },
};
</script>
<style lang="scss">
header {
  background: rgba(255, 255, 255, 0.4) !important;
  .v-toolbar__title {
    font-size: 36px !important;
  }
  .v-btn__content {
    font-weight: bold;
  }
  .v-icon {
    color:#19286E !important;
  }
}
.menu-header-mobile {
  a {
    text-decoration: none;
    display: block;
  }
}

.oiu{
  width: 100%;
}
</style>
